import { commonFilter } from './filter';

export default function (path: string, pageName = 'GPT Auto Reports') {
  return {
    pageName,
    pageId: '20019',
    pagePath: path,
    common: {
      source: 2,
      typeId: 'opinion_pc_v2',
    },
    button: {
      ...commonFilter,
      Report_Tab: {
        buttonId: '2001901',
      },
    },
  };
}
